import React from 'react';
import Header from '../../header/Header';
import Footer from '../../footer/Footer';
import './personal.css';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faBrain, faCode, faCamera, faGamepad, faGlobe } from '@fortawesome/free-solid-svg-icons';

const pythoncir = process.env.PUBLIC_URL + '/Sharad_Naik.pdf';

const Personal = () => {
  const opencerti = (value) => {
    if (value) window.open(value, '_blank');
  };

  const certificates = [
    { title: "Internship PCB Design", icon: faCertificate, link: null, provider: "Industry Program" },
    { title: "Introduction to Python", icon: faCode, link: pythoncir, provider: "Coursera" },
  ];

  const hobbies = [
    { name: "Electronics & PCB Design", icon: faBrain, desc: "Building custom hardware and circuit boards." },
    { name: "Open Source Contribution", icon: faCode, desc: "Contributing to various tech communities." },
    { name: "Travelling", icon: faCamera, desc: "Once a year, go someplace you've never been before." },
    // { name: "Gaming", icon: faGamepad, desc: "Exploring immersive virtual worlds and strategy." },
    { name: "Exploring New Tech", icon: faGlobe, desc: "Always learning about AI, LLMs, and robotics." },
  ];

  return (
    <div className='personal-page'>
      <Header />
      
      <main className='personal-content'>
        <motion.section 
          className="personal-hero"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="stroke-text">Personal</h1>
          <h2>Journey & Interests</h2>
          <p>A glimpse into my professional certifications and the things that inspire me beyond the code.</p>
        </motion.section>

        <section className="personal-grid-section">
          <div className="section-header">
            <FontAwesomeIcon icon={faCertificate} className="section-icon" />
            <h3>Certifications</h3>
          </div>
          <div className="certificates-grid">
            {certificates.map((cert, index) => (
              <motion.div 
                key={index}
                className="cert-card"
                whileHover={{ scale: 1.02, translateY: -5 }}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                onClick={() => opencerti(cert.link)}
              >
                <div className="cert-icon-box">
                  <FontAwesomeIcon icon={cert.icon} />
                </div>
                <div className="cert-info">
                  <h4>{cert.title}</h4>
                  <span>{cert.provider}</span>
                </div>
                <div className="cert-badge">Verified</div>
              </motion.div>
            ))}
          </div>
        </section>

        <section className="personal-grid-section">
          <div className="section-header">
            <FontAwesomeIcon icon={faBrain} className="section-icon" />
            <h3>Hobbies & Interests</h3>
          </div>
          <div className="hobbies-grid">
            {hobbies.map((hobby, index) => (
              <motion.div 
                key={index}
                className="hobby-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 + (index * 0.1) }}
              >
                <FontAwesomeIcon icon={hobby.icon} className="hobby-icon" />
                <h4>{hobby.name}</h4>
                <p>{hobby.desc}</p>
              </motion.div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Personal;
